import React, { useRef, useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import SearchIcon from '@mui/icons-material/Search'
import { withRouter } from '../../actions/withRouterHook'
import Button from '@mui/material/Button'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import logout from '../../images/svg/logout.svg'
import login from '../../images/svg/login.svg'
import { bindActionCreators } from 'redux'
import { logoutUser, logSearch } from '../../actions/userActions'
import { applyFilter, showPopup } from '../../actions/uiActions'
import DropDownMenu from './DropDownMenu'
import TagsSelect from '../../components/ui/TagsSelect'
import ExitToAppIcon from '@mui/icons-material/ExitToApp'

function TopBar(props) {
    let navigate = useNavigate()
    let [globalSearch, setGlobalSearch] = useState("")
    let [userHover, setUserHover] = useState(false)
    let anchorRef = useRef(null)

    return (
        <>
            <div className="topSection">
                {renderSearchBox()}
                {renderTagsDropDown()}
                <div className="topRight">
                    <div className="userDropOut">
                        <Button
                            ref={anchorRef}
                            aria-controls={userHover ? 'menu-list-grow' : undefined}
                            aria-haspopup="true"
                            onClick={handleHover}
                        >
                            <AccountCircleIcon />
                            <span className="userNameDrop">{(props.email !== null) ? props.email : "My User"}</span>
                            <pre>
                                <ExpandMoreIcon />
                            </pre>
                        </Button>
                        {renderDropDown()}
                    </div>
                    <Button onClick={(e) => handleLogout(e)}>
                        <ExitToAppIcon />
                        <em>Logout</em>
                    </Button>
                </div>
            </div>
        </>
    )

    function handleHover() {
        // TODO: I think we should have a more central function for cases like this
        let regularCommand = (window.location.pathname  !== "/databasefunctions");
        if (regularCommand) {
            if (userHover) {
                hideMenu()
            } else {
                showMenu()
            }   
        }
    }

    function leaveHover(event) {
        event.preventDefault()
        hideMenu()
    }

    function handleLogout(event){
        event.preventDefault()
        props.logoutUser()
        navigate("/")
    }

    function handleKeyUp(event) {
        event.preventDefault()
        setGlobalSearch(event.target.value)
    }

    function handleSearch(event) {
        event.preventDefault()
        let reducerName = window.location.pathname.substring(1)
        props.applyFilter(globalSearch, reducerName)
        // log search
        logSearch(globalSearch)
    }

    function showMenu(str = null) {
        if (props.loggedIn) {
            setUserHover(true)
        }
    }

    function hideMenu(str = null) {
        setUserHover(false)
    }

    function camelCase(string) {
        return string.split(" ")
            .map((x, i) => {
                if (i !== 0) {
                    return x.charAt(0).toUpperCase() + x.slice(1)
                } else {
                    return x
                }
            }).join("")
    }

    function goToUser() {
        navigate("/myUser")
    }

    function openChangePassword() {
        navigate('/myUser')
        props.showPopup("changePassword")
    }

    function handleLogoutUser() {
        props.logoutUser()
        navigate('/')
    }

    function renderLoginLogout() {
        if (props.loggedIn) {
            return (<img className="iconButton" alt="Logout" src={logout} onClick={handleLogout} style={{ 'position': 'absolute', 'right': '50px', 'top': '23px', 'height': '25px', 'width': '25px' }} id="logout_btn" />)
        } else {
            return (<img className="iconButton" alt="Login" src={login} onClick={handleLogout} style={{ 'position': 'absolute', 'right': '50px', 'top': '23px', 'height': '25px', 'width': '25px' }} />)
        }
    }

    function renderDropDown() {
        return (userHover) ?
            <DropDownMenu
                vname={anchorRef}
                name="myUser"
                hideMenu={hideMenu}
                showMenu={showMenu}
                handleLogoutUser={handleLogoutUser}
                goToUser={goToUser}
                openChangePassword={openChangePassword} /> : null
    }

    function renderSearchBox() {
        let classList = 'topLeft';
        if (window.location.pathname.startsWith("/presentations/")) {
            classList += ' hideMe';
        } else if (window.location.pathname === "/databasefunctions") {
            classList += ' hideMe';
        }

        return (
            <div className={classList}>
                <SearchIcon onClick={handleSearch} />
                <input
                    type="text"
                    placeholder="Search here ..."
                    name="search"
                    className="myInput"
                    onChange={handleKeyUp}
                    onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                            handleSearch(e)
                        }
                    }}
                    value={globalSearch}
                />
            </div>
        )
    }

    function renderTagsDropDown() {
        if (props.loggedIn) {
            let classList = 'formControl-Select';
            if (window.location.pathname !== "/presentations") {
                classList += ' hideMe';
            }

            return (
                <div className={classList}>
                    <TagsSelect
                        {...props}
                    />
                </div>
            )
        }
    }
}

function mapStateToProps(state) {
    return {
        loggedIn: state.users.loggedIn,
        role: state.users.role,
        email: state.users.email,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ logoutUser, applyFilter, showPopup }, dispatch)
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TopBar))